export type AgencyBrand = {
  id: string;
  name: string;
  mark: string;
  primary: string;
  secondary: string;
  accent: string;
  surface: string;
};

export const agencyBrands: AgencyBrand[] = [
  {
    id: "leadstack",
    name: "LeadStack",
    mark: "LS",
    primary: "#0f8f7e",
    secondary: "#5b65d8",
    accent: "#d98913",
    surface: "#ffffff"
  },
  {
    id: "north-market",
    name: "North Market",
    mark: "NM",
    primary: "#236cbe",
    secondary: "#0f8f7e",
    accent: "#c1554d",
    surface: "#fbfcfe"
  },
  {
    id: "amberline",
    name: "Amberline",
    mark: "AL",
    primary: "#7a5cba",
    secondary: "#18716a",
    accent: "#cc7a1d",
    surface: "#fffefd"
  }
];

export function findBrand(id: string): AgencyBrand {
  return agencyBrands.find((brand) => brand.id === id) ?? agencyBrands[0];
}

export function applyBrandTheme(brand: AgencyBrand, root: HTMLElement = document.documentElement): void {
  root.style.setProperty("--brand-primary", brand.primary);
  root.style.setProperty("--brand-secondary", brand.secondary);
  root.style.setProperty("--brand-accent", brand.accent);
  root.style.setProperty("--brand-surface", brand.surface);
}
